import { estada } from "../apis/core-api";

//
// Registry for extension and their implementations.
//

const Extensions_Registry: estada.IExtensionRegistry = {
    gira_GPA: () => import("./exports/gira_GPA/register"),
    ets_import: () => import("./imports/ets/register"),
    // weitere...
};
export default Extensions_Registry



